module.exports = __webpack_public_path__ + "img/kin5.311938af.jpg";